var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46366 4.77948C1.17114 4.77948 0.941092 5.02949 0.965384 5.321L1.6876 13.9876C1.77398 15.0242 2.64051 15.8215 3.68069 15.8215H9.20184C10.242 15.8215 11.1085 15.0242 11.1949 13.9876L11.9171 5.321C11.9414 5.02949 11.7114 4.77948 11.4189 4.77948H1.46366Z",
    fill: "#DD0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28151 1.09867V1.09867C8.28151 0.590471 7.86954 0.178497 7.36134 0.178497H5.52101C5.01281 0.178497 4.60084 0.590471 4.60084 1.09867V1.09867L0.812954 1.85624C0.340256 1.95078 0 2.36583 0 2.84789V2.84789C0 3.4064 0.452767 3.85917 1.01128 3.85917H11.8711C12.4296 3.85917 12.8824 3.4064 12.8824 2.84789V2.84789C12.8824 2.36583 12.5421 1.95078 12.0694 1.85624L8.28151 1.09867Z",
    fill: "#DD0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.672b735e0c7d8d8dbccf654a6709e717.svg";
export { ForwardRef as ReactComponent };